import LiveSubProfilePic from "../../../../../assets/subscriptions/ProfilePhoto2Update.png";
import { LiveSubscriptionType } from "../../../types/LiveSubscriptionTypes.ts";
import { useAppDispatch } from "../../../../../state/state.tsx";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice.ts";
import parsePhoneNumber from 'libphonenumber-js';
import { useState } from 'react';
import ChangePhoneNumberModal from './ChangePhoneNumberModal';

import {
    setFieldsForDeleteLiveSubscriptionModal,
    setFieldsForEditLiveSubscriptionModal,
    setFieldsForMultiMonthPauseModal,
    setFieldsForMultiMonthResumeModal,
    setFieldsForPauseLiveSubscriptionModal,
    setFieldsForResumeLiveSubscriptionModal,
    setFieldsForTerminateLiveSubscriptionModal,
    setFieldsForCancelPauseModal,
    setFieldsForSingleRaiseInvoiceModal,
    setFieldsForQuickCollectModal,
    setFieldsForMoveStudentModal
} from "../../../../../state/ArbitrarySlice/ArbitratySlice.ts";
import { toast } from "react-toastify";
import { formatDateAsDDMMYYYY, getFutureCycles } from "../../../../Common/utilityFunctions.ts";
import { SubscriptionType } from "../../../../../enums.ts";
import { differenceInDays } from "date-fns";


export default function LiveSubInformationSection({ selectedLiveSubDoc, selectedSubscriptionPrice, isAlign2monthBoundary, NoGSTBatch, serviceProviderId, onDataRefresh }: {
    selectedLiveSubDoc: LiveSubscriptionType,
    selectedSubscriptionPrice: number,
    isAlign2monthBoundary: boolean,
    NoGSTBatch: boolean,
    serviceProviderId: string,
    onDataRefresh?: () => void
}) {

    const Dispatch = useAppDispatch();
    const [showChangePhoneModal, setShowChangePhoneModal] = useState(false);
    // OnClickHandlers


    function CheckIfInvoiceCanBeRaised() {
        if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) {
            return {
                error: false,
                message: `Invoice can be raised`
            }


        } else if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) {

            if (selectedLiveSubDoc.lastOrderStatus === "Pending") {
                return {
                    error: true,
                    message: `A pending order already exists. Please review and make the necessary updates to the existing order.`
                }
            }

            const remainingCount = selectedLiveSubDoc.remainingCount
            const endDate = new Date(selectedLiveSubDoc.billingEnd)
            const currentDate = new Date()
            const diffInDays = differenceInDays(endDate, currentDate)

            if (remainingCount <= 3 || diffInDays < 15) {
                return {
                    error: false,
                    message: `An invoice can be raised for ${remainingCount % 1 === 0 ? remainingCount : remainingCount.toFixed(2)} remaining classes`
                }
            } else {
                return {
                    error: true,
                    message: `An invoice can be raised only if the remaining classes are less than 3.`
                }
            }
        } else if (selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) {

            if (selectedLiveSubDoc.lastOrderStatus === "Pending") {
                return {
                    error: true,
                    message: `A pending order already exists. Please review and make the necessary updates to the existing order.`
                }
            }

            const endDate = new Date(selectedLiveSubDoc.billingEnd)
            const currentDate = new Date()
            const diffInDays = differenceInDays(endDate, currentDate)
            if (diffInDays < 15) {
                return {
                    error: false,
                    message: `An invoice can be raised for ${diffInDays} days`
                }
            } else {
                return {
                    error: true,
                    message: `An invoice can be raised only if the remaining days are less than 15.`
                }
            }
        }

        return {
            error: true,
            message: `Invoice cannot be raised for ${selectedLiveSubDoc.subscriptionType} subscription`
        }
    }



    function onClickPause() {
        if (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) {
            toast.info("Pause is not applicable for Count Subscription")
            return;
        }

        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated Student cannot be paused")
            return;
        }

        if (selectedLiveSubDoc.status === "InActive") {
            toast.error("Inactive Student cannot be paused")
            return;
        }

        if (selectedLiveSubDoc.cycle === "MultiMonth") {
            Dispatch(openModal("MultiMonthPauseModalOpen"))

            Dispatch(setFieldsForMultiMonthPauseModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                align2monthlyBoundary: isAlign2monthBoundary
            }))
        } else {
            Dispatch(openModal("PauseLiveSubscriptionModalOpen"))
            Dispatch(setFieldsForPauseLiveSubscriptionModal({
                subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
                LiveSubscriptionId: selectedLiveSubDoc.id
            }))
        }

    }

    function onClickTerminate() {

        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Student is already Terminated")
            return;
        }
        Dispatch(openModal("TerminateLiveSubscriptionModalOpen"))

        Dispatch(setFieldsForTerminateLiveSubscriptionModal({
            SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
            LiveSubscriptionId: selectedLiveSubDoc.id
        }))
    }

    function onClickDelete() {
        if (selectedLiveSubDoc.status !== "Terminated") {
            toast.error("Terminate the subscriber before deleting.")
            return;
        }
        Dispatch(openModal("DeleteLiveSubscriptionModalOpen"))

        Dispatch(setFieldsForDeleteLiveSubscriptionModal({
            SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
            LiveSubscriptionId: selectedLiveSubDoc.id
        }))
    }

    function onClickEditLiveSubscription(LiveSubscriptionId: string) {
        Dispatch(openModal("EditLiveSubscriptionModalOpen"))
        Dispatch(setFieldsForEditLiveSubscriptionModal({ LiveSubscriptionId: LiveSubscriptionId, SubscriptionPrice: selectedSubscriptionPrice, NoGSTBatch: NoGSTBatch }))
    }

    function onClickResume() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated Subscriber cannot be Resumed")
            return;
        }
        if (selectedLiveSubDoc.cycle === "MultiMonth") {
            Dispatch(openModal("MultiMonthResumeModalOpen"))
            Dispatch(setFieldsForMultiMonthResumeModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                align2monthlyBoundary: isAlign2monthBoundary
            }))
        } else {
            Dispatch(openModal("ResumeLiveSubscriptionModalOpen"))
            Dispatch(setFieldsForResumeLiveSubscriptionModal({
                LiveSubscriptionId: selectedLiveSubDoc.id,
                SubscriptionId: selectedLiveSubDoc.subscriptionPlanRefId,
                chargeNowVisible: selectedLiveSubDoc.invoiceCycleList ? !selectedLiveSubDoc.invoiceCycleList.includes(getFutureCycles()[0]) : true
            }))
        }
    }

    function onClickCancelPause() {
        Dispatch(openModal("CancelPauseModalOpen"))
        Dispatch(setFieldsForCancelPauseModal({ LiveSubscriptionId: selectedLiveSubDoc.id, align2monthlyBoundary: isAlign2monthBoundary }))

    }

    function onClickSingleRaiseInvoice() {

        if (selectedLiveSubDoc.status === "Terminated" || selectedLiveSubDoc.status === "InActive" || selectedLiveSubDoc.status === "Paused") {
            toast.error(`Invoice cannot be raised for ${selectedLiveSubDoc.status} subscriber`)
            return;
        }

        const { error, message } = CheckIfInvoiceCanBeRaised()
        if (error) {
            toast.error(message)
            return;
        }
        Dispatch(setFieldsForSingleRaiseInvoiceModal({ subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId, liveSubId: selectedLiveSubDoc.id }))
        Dispatch(openModal("SingleRaiseInvoiceModalOpen"))
        // Dispatch(setFieldsForRaiseInvoiceModal({ LiveSubscriptionId: selectedLiveSubDoc.id }))
    }



    function onClickQuickCollect() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error(`Quick Collect is not applicable for ${selectedLiveSubDoc.status} subscriber`)
            return;
        }

        Dispatch(setFieldsForQuickCollectModal({ subscriptionId: selectedLiveSubDoc.subscriptionPlanRefId, liveSubId: selectedLiveSubDoc.id }))
        Dispatch(openModal("QuickCollectModalOpen"))

    }

    function onClickMoveStudent() {
        if (selectedLiveSubDoc.status === "Terminated") {
            toast.error("Terminated student cannot be moved")
            return;
        }

        Dispatch(setFieldsForMoveStudentModal({ 
            LiveSubscriptionId: selectedLiveSubDoc.id,
            currentSubscriptionType: selectedLiveSubDoc.subscriptionType
        }))
        Dispatch(openModal("MoveStudentModalOpen"))

    }


    const hasFuturePause = () => {
        if (!selectedLiveSubDoc.pauseHistory || selectedLiveSubDoc.pauseHistory.length === 0) return false;
        const lastPause = selectedLiveSubDoc.pauseHistory[selectedLiveSubDoc.pauseHistory.length - 1];
        const pauseDate = lastPause.pauseTS?.toDate?.() || new Date(lastPause.pauseTS);

        return pauseDate.getTime() > new Date().getTime();
    };

    const getMMPrice = () => {
        let assignedPlanPrice = 0;
        assignedPlanPrice = selectedLiveSubDoc.assignedPlans[selectedLiveSubDoc.assignedPlanIndex].price;
        return ((Number(assignedPlanPrice) * selectedLiveSubDoc.priceMultiplier)) + selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)
    }

    if (!selectedLiveSubDoc) {

        return <div>Please select a live sub</div>
    }

    const phoneNumber = parsePhoneNumber(selectedLiveSubDoc.phoneNumber)

    return (
        <div
            className={"header w-full rounded-xl bg-cc_bg_ap p-5 flex flex-col   border-solid border-[1px] border-cc_modal-grey-border"}>
            <div className={"flex items-center w-full"}>
                <div className={"flex-shrink-0 p-2 bg-white rounded-full border-solid border-gray-400 border-2 flex"}>
                    <img
                        className="inline-block size-16 rounded-full ring-2 ring-white"
                        src={selectedLiveSubDoc.photoUrl || LiveSubProfilePic}
                        alt="Profile"
                    />
                </div>
                <div className={"ml-2.5 max-w-[30%]"}>
                    <p className={"text-lg font-semibold overflow-x-hidden overflow-ellipsis"}>{selectedLiveSubDoc.studentName}</p>
                    <div className="flex items-center gap-2">
                        <p className={""}>{phoneNumber?.formatInternational() || selectedLiveSubDoc.phoneNumber}</p>
                        <button
                            onClick={() => setShowChangePhoneModal(true)}
                            className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50 transition-colors"
                            title="Change phone number"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                        </button>
                    </div>
                    <p className={"text-xs font-semibold mt-1 text-blue-800"}>id : {selectedLiveSubDoc.id}</p>
                    <button
                        onClick={onClickMoveStudent}
                        className="mt-2 text-sm bg-purple-600 hover:bg-purple-700 text-white px-3 py-1.5 rounded-md transition-colors flex items-center gap-1.5"
                        title="Move student to another batch"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="17 11 12 6 7 11"></polyline>
                            <polyline points="17 18 12 13 7 18"></polyline>
                        </svg>
                        Move Student
                    </button>
                </div>
                <div className={"grid grid-cols-2 gap-2 ml-6 w-fit"}>

                    <button onClick={() => {
                        onClickEditLiveSubscription(selectedLiveSubDoc.id)
                    }}

                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                        <div className={"mr-1.5"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                strokeLinejoin="round" className="feather feather-edit">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                            </svg>
                        </div>
                        Edit
                    </button>

                    <div>
                        {selectedLiveSubDoc.status === "Paused" ? (
                            <button onClick={onClickResume}
                                className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                                <div className={"mr-1.5"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-play">
                                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                                    </svg>
                                </div>
                                Resume
                            </button>
                        ) : selectedLiveSubDoc.subscriptionType === "MultiMonth" && hasFuturePause() ? (
                            <button onClick={onClickCancelPause}
                                className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                                <div className={"mr-1.5"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-x-circle">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <line x1="15" y1="9" x2="9" y2="15"></line>
                                        <line x1="9" y1="9" x2="15" y2="15"></line>
                                    </svg>
                                </div>
                                Cancel Pause
                            </button>
                        ) : (
                            <button onClick={onClickPause}
                                className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                                <div className={"mr-1.5"}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                        strokeLinejoin="round" className="feather feather-pause">
                                        <rect x="6" y="4" width="4" height="16"></rect>
                                        <rect x="14" y="4" width="4" height="16"></rect>
                                    </svg>
                                </div>
                                Pause
                            </button>
                        )}
                    </div>

                    <button onClick={onClickTerminate}

                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                        <div className={"mr-1.5"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                strokeLinejoin="round" className="feather feather-minus-square">
                                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="8" y1="12" x2="16" y2="12"></line>
                            </svg>
                        </div>
                        Terminate
                    </button>
                    <button onClick={onClickDelete}

                        className={"bg-gray-100 border-[1px] border-gray-400 hover:bg-gray-200 text-black p-2 shadow-sm rounded-md text-sm flex justify-center items-center w-[110px] h-[36px]"}>
                        <div className={"mr-1.5"}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-trash-2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                        </div>
                        Delete
                    </button>
                </div>
            </div>
            {selectedLiveSubDoc.subscriptionType === SubscriptionType.Count && selectedLiveSubDoc.status !== "InActive" && <div className="text-lg mt-4 mb-1 font-semibold pl-6">
                <p>Remaining Classes : {selectedLiveSubDoc.remainingCount % 1 === 0 ? selectedLiveSubDoc.remainingCount : selectedLiveSubDoc.remainingCount.toFixed(2)}</p>
            </div>}

            <div className="bg-white rounded-lg ml-1 shadow-md border border-gray-200 w-[80%] my-4 overflow-hidden text-sm">
                <div className="bg-cc_brand text-white p-2  flex justify-between items-center">
                    <h2 className="text-base font-bold">Subscription Details</h2>
                </div>
                <div className="p-3 bg-gray-50">
                    <div className="mb-2">
                        <div className="grid grid-cols-2 ">
                            <div>
                                <span className="text-gray-600">Service:</span>
                                <span className="font-medium ml-1">{selectedLiveSubDoc.serviceType}</span>
                            </div>
                            <div className="pl-4">
                                <span className="text-gray-600">Status:</span>
                                <span className={`font-medium ml-1 ${selectedLiveSubDoc.status === "Active"
                                    ? "text-cc_success"
                                    : selectedLiveSubDoc.status === "Paused"
                                        ? "text-cc_bg-paused"
                                        : "text-cc_error"
                                    }`}>
                                    {selectedLiveSubDoc.status}
                                </span>
                            </div>
                        </div>
                        <div className="mt-1 grid grid-cols-2 gap2">
                            {(selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth || selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) &&
                                (selectedLiveSubDoc.status === "Active" || selectedLiveSubDoc.status === "Paused") &&
                                selectedLiveSubDoc.billingEnd && (

                                    <div className="">
                                        <span className="text-gray-600">Validity:</span>
                                        <span className="font-medium ml-1">
                                            {formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.billingStart))} - {formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.billingEnd))}
                                        </span>
                                    </div>
                                )}
                            {/* {(selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth || selectedLiveSubDoc.subscriptionType === SubscriptionType.Count) &&
                                <div className={`${(selectedLiveSubDoc.status === "Active" || selectedLiveSubDoc.status === "Paused") ? "pl-4" : "pl-0"}`}>
                                    <span className="text-gray-600">Discount:</span>
                                    <span className="font-medium ml-1">₹{selectedLiveSubDoc.discountNegotiated}</span>
                                </div>
                            } */}
                            {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) && (
                                <div className="pl-0">
                                    <span className="text-gray-600">Start Date:</span>

                                    <span className="font-medium ml-1">{formatDateAsDDMMYYYY(new Date(selectedLiveSubDoc.startDate))}</span>
                                </div>
                            )}
                        </div>



                    </div>

                    <div className="bg-white p-2 rounded border border-gray-200">

                        {selectedLiveSubDoc.serviceType !== "CableTV" && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">{selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth ? `Plan Price ( ${selectedLiveSubDoc.assignedPlans?.[selectedLiveSubDoc.assignedPlanIndex || 0]?.billingCycle} ) ` : "Plan Price"}:</span>
                                <span className="font-medium">₹{(selectedLiveSubDoc.subscriptionType === SubscriptionType.Monthly) ? selectedLiveSubDoc.Price || selectedSubscriptionPrice : (selectedLiveSubDoc.assignedPlans?.[selectedLiveSubDoc.assignedPlanIndex || 0]?.price)}</span>
                            </div>
                        )}
                        {selectedLiveSubDoc.serviceType !== "CableTV" && (selectedLiveSubDoc.subscriptionType !== SubscriptionType.Count && selectedLiveSubDoc.subscriptionType !== SubscriptionType.MultiMonth) && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">(Multiplier :{selectedLiveSubDoc.priceMultiplier}, Discount :₹{selectedLiveSubDoc.discountNegotiated})</span>

                            </div>
                        )}
                        {/* {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) && (
                            <div className="flex justify-between items-center mb-1">
                                <span className="text-gray-600">(Discount :₹{selectedLiveSubDoc.discountNegotiated})</span>

                            </div>
                        )} */}

                        {selectedLiveSubDoc.products && selectedLiveSubDoc.products.length > 0 && (
                            selectedLiveSubDoc.products.map((product, index) => (
                                product && Object.keys(product).length > 0 && (
                                    <div key={index} className="flex justify-between items-center mb-1">
                                        <span className="text-gray-600">{product.name}:</span>
                                        <span className="font-medium">₹{product.price}</span>
                                    </div>
                                )
                            ))
                        )}
                        <div className="flex justify-between items-center pt-1 border-t border-gray-200 mt-1">
                            <span className="font-bold text-cc_brand">Total Charges:</span>
                            <span className="font-bold text-cc_brand">
                                ₹{selectedLiveSubDoc.serviceType !== "CableTV"
                                    ? (selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth)
                                        ? getMMPrice()
                                        : ((Number(selectedLiveSubDoc.Price || selectedSubscriptionPrice) * selectedLiveSubDoc.priceMultiplier) - selectedLiveSubDoc.discountNegotiated) + selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)
                                    : selectedLiveSubDoc.products.reduce((sum, product) => sum + Number(product.price || 0), 0)}
                            </span>
                        </div>

                        {/* Add Raise Invoice button */}
                        {<div className="mt-3 flex justify-end gap-2.5">
                            <button
                                onClick={() => {
                                    onClickQuickCollect()
                                }}
                                className="bg-cc_brand text-white px-10 py-2 rounded-lg flex items-center hover:bg-cc_brand/90 transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-file-text mr-2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                                Quick Collect
                            </button><button
                                onClick={() => {
                                    onClickSingleRaiseInvoice()
                                }}
                                className="bg-cc_brand text-white px-10 py-2 rounded-lg flex items-center hover:bg-cc_brand/90 transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" className="feather feather-file-text mr-2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                                    <polyline points="14 2 14 8 20 8"></polyline>
                                    <line x1="16" y1="13" x2="8" y2="13"></line>
                                    <line x1="16" y1="17" x2="8" y2="17"></line>
                                    <polyline points="10 9 9 9 8 9"></polyline>
                                </svg>
                                Raise Invoice
                            </button>
                        </div>}
                    </div>
                    {selectedLiveSubDoc.serviceType !== "CableTV" && (selectedLiveSubDoc.subscriptionType !== SubscriptionType.Count && selectedLiveSubDoc.subscriptionType !== SubscriptionType.MultiMonth) && (
                        <div className="text-xs text-gray-500 mt-1">
                            *Charges = (Plan Price x Multiplier) - Discount + Products
                        </div>
                    )}
                    {(selectedLiveSubDoc.subscriptionType === SubscriptionType.Count || selectedLiveSubDoc.subscriptionType === SubscriptionType.MultiMonth) && (
                        <div className="text-xs text-gray-500 mt-1">
                            *Charges = Plan Price - Discount
                        </div>
                    )}
                </div>
            </div>

            {/* Change Phone Number Modal */}
            <ChangePhoneNumberModal
                open={showChangePhoneModal}
                onClose={() => setShowChangePhoneModal(false)}
                currentPhoneNumber={selectedLiveSubDoc.phoneNumber}
                studentName={selectedLiveSubDoc.studentName}
                liveSubscriptionId={selectedLiveSubDoc.id}
                serviceProviderId={serviceProviderId}
                onPhoneNumberChanged={() => {
                    onDataRefresh?.();
                    setShowChangePhoneModal(false);
                }}
            />
        </div>
    )
}